<template>
    <q-list class="profile-nav">
        <div v-if="isStudent">
            <q-item to="/profile" exact>
                <q-item-section avatar>
                    <q-icon name="account_box" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.my_profile') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/my-tax-address" exact>
                <q-item-section avatar>
                    <q-icon name="home" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.my_tax_address') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/my-account" exact>
                <q-item-section avatar>
                    <q-icon name="lock" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.my_account') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/my-affiliations" exact>
                <q-item-section avatar>
                    <q-icon name="badge" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.my_affiliations') }}
                </q-item-section>
            </q-item>
            <!-- <q-item to="/profile/notifications" exact>
                <q-item-section avatar>
                    <q-icon name="eva-bell" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.notifications') }}
                </q-item-section>
            </q-item> -->
            <q-item to="/profile/my-courses" exact>
                <q-item-section avatar>
                    <q-icon name="school" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.my_courses') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/certificates" exact>
                <q-item-section avatar>
                    <q-icon name="verified" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.certificates') }}
                </q-item-section>
            </q-item>
            <!-- <q-item to="/profile/current-account" exact>
                <q-item-section avatar>
                    <q-icon name="account_balance" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.current_account') }}
                </q-item-section>
            </q-item> -->
            <q-item to="/profile/orders-history" exact>
                <q-item-section avatar>
                    <q-icon name="history" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.orders_history') }}
                </q-item-section>
            </q-item>
            <!-- <q-item to="/profile/payment-methods" exact>
                <q-item-section avatar>
                    <q-icon name="credit_card" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.payment_methods') }}
                </q-item-section>
            </q-item> -->
            <!-- <q-item to="/profile/achievements" exact>
                <q-item-section avatar>
                    <q-icon name="analytics" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.goals_and_achievments') }}
                </q-item-section>
            </q-item> -->
        </div>
        <div v-if="isClient">
            <q-item to="/profile" exact>
                <q-item-section avatar>
                    <q-icon name="account_box" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.my_profile') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/my-account" exact>
                <q-item-section avatar>
                    <q-icon name="lock" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.my_account') }}
                </q-item-section>
            </q-item>
            <!-- <q-item to="/profile/notifications" exact>
                <q-item-section avatar>
                    <q-icon name="eva-bell" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.notifications') }}
                </q-item-section>
            </q-item> -->

            <q-separator />

            <q-item to="/profile/organization" exact>
                <q-item-section avatar>
                    <q-icon name="business" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.organization') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/my-tax-address" exact>
                <q-item-section avatar>
                    <q-icon name="home" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.our_tax_address') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/employees" exact>
                <q-item-section avatar>
                    <q-icon name="groups" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.employees') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/our-courses" exact>
                <q-item-section avatar>
                    <q-icon name="school" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.our_courses') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/certificates" exact>
                <q-item-section avatar>
                    <q-icon name="verified" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.certificates') }}
                </q-item-section>
            </q-item>
            <q-item to="/profile/orders-history" exact>
                <q-item-section avatar>
                    <q-icon name="history" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.orders_history') }}
                </q-item-section>
            </q-item>
            <!-- <q-item to="/profile/payment-methods" exact>
                <q-item-section avatar>
                    <q-icon name="credit_card" />
                </q-item-section>
                <q-item-section class="capitalize-text">
                    {{ $t('profile.payment_methods') }}
                </q-item-section>
            </q-item> -->
        </div>
    </q-list>
</template>

<script>
import store from '@/store'

export default {
    data() {
        return {}
    },

    computed: {
        user() {
            return store.getters['session/user']
        },

        userHasRoles() {
            return this.user && this.user.userRoles
        },

        isStudent() {
            if (this.userHasRoles && this.user.userRoles.name === 'student') {
                return true
            } else {
                return false
            }
        },

        isClient() {
            if (this.userHasRoles && this.user.userRoles.name === 'client') {
                return true
            } else {
                return false
            }
        },
    },
}
</script>
